import { colors, fontSizes } from '../../../../Components/consts'
import { styled } from '@mui/system'

type SummaryStyleProps = {
  uiTheme?: 'light' | 'dark'
}

type SummaryProps = {
  selected: boolean
  correct: string
  uiTheme?: 'light' | 'dark'
}

export const SummaryStyle = styled('div')<SummaryStyleProps>(({ uiTheme, theme }) => ({
  margin: theme.spacing(2, 1, 4),
  backgroundColor: uiTheme === 'dark' ? 'none' : colors.gray.gray20,
  padding: theme.spacing(2, 1),
  borderRadius: 8,
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(2, 0, 4),
  },
}))

export const SummaryRowStyle = styled('div')<SummaryProps>(
  ({ selected, correct, uiTheme, theme }) => ({
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(1.5, 2),
    borderRadius: 6,
    backgroundColor: uiTheme === 'dark' ? colors.gray.gray80 : colors.offWhite,
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
      margin: theme.spacing(0.5, 1),
    },
    '& .circleCon': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 18,
      height: 18,
      margin: theme.spacing(1, 2),
      [theme.breakpoints.down('md')]: {
        width: 15,
        height: 15,
        margin: theme.spacing(1),
      },
      '& .circle': {
        width: 18,
        height: 18,
        borderRadius: '50%',
        backgroundColor: getColor(selected, correct),
        [theme.breakpoints.down('md')]: {
          width: 15,
          height: 15,
        },
      },
    },
    '& .questionCon': {
      display: 'flex',
      flexDirection: 'column',
      '& .question': {
        color: uiTheme === 'dark' ? colors.white : colors.text,
        fontSize: fontSizes.medium,
        fontWeight: 'bold',
        margin: theme.spacing(1, 1, 0.5),
        [theme.breakpoints.down('md')]: {
          fontSize: fontSizes.xSmall,
          fontWeight: 500,
        },
      },
      '& .selectedText': {
        color: colors.gray.gray60,
        fontSize: fontSizes.small,
        fontWeight: 'bold',
        margin: theme.spacing(0, 1, 1),
        [theme.breakpoints.down('md')]: {
          fontSize: fontSizes.xSmall,
          fontWeight: 500,
        },
      },
      '& .unselectedText': {
        color: colors.yellow,
        fontSize: fontSizes.small,
        fontWeight: 'bold',
        margin: theme.spacing(0, 1, 1),
        [theme.breakpoints.down('md')]: {
          fontSize: fontSizes.xSmall,
          fontWeight: 500,
        },
      },
    },
  })
)

const getColor = (selected: boolean, correct: string) => {
  switch (selected) {
    case true:
      if (correct === 'incorrect') {
        return colors.red
      }
      if (correct === 'correct') {
        return colors.limeGreen
      }
      if (correct === 'neutral' || correct === '') {
        return colors.yellow
      }
      return colors.gray.gray60
    case false:
      if (correct === 'incorrect') {
        return colors.red
      }
      return colors.gray.gray60
    default:
      return colors.gray.gray60
  }
}
